import { render } from "./SlideInfo.vue?vue&type=template&id=2c7a7279&scoped=true"
import script from "./SlideInfo.vue?vue&type=script&lang=js"
export * from "./SlideInfo.vue?vue&type=script&lang=js"

import "./SlideInfo.vue?vue&type=style&index=0&id=2c7a7279&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7a7279"]])

export default __exports__